export default "__VITE_ASSET__9569f97b__"